module.exports = __webpack_public_path__ + "media/1fie-i-musikw.c4b4f18f.mp3";